import React from "react";
import downloadIcon from "./img/downloadIcon.png";
import { degrees, PDFDocument, rgb, StandardFonts, TextAlignment } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import { useConfig } from "./ConfigContext";

const fontSize = 14;
const pageXMargin = 24;
const maxLineNumber = 36;

const exportFullPDF = false;
const exportEmptyPDF = false;

export default function DatenblattPDF({
   titleimageURL,
   allKacheln,
   ownerData,
   bemerkungsfeld,
   basicdata,
   estatekacheln,
}) {
   const config=useConfig()
   function addNewPage(pdfDoc, pageNumber, regularFont, objNr) {
      let newPage = pdfDoc.addPage();
      const { width, height } = newPage.getSize();

      newPage.drawText(objNr + "     - " + pageNumber + " -", {
         x: width - 100,
         y: 20,
         size: 10,
         font: regularFont,
         color: rgb(0, 0, 0),
      });
      pageNumber++;
      return [newPage, pageNumber];
   }
   async function createPdf() {
      const pdfDoc = await PDFDocument.create();
      const regularFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
      const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
      pdfDoc.registerFontkit(fontkit);

      let pageNumber = 1;
      let page;

      /* console.log(estatekacheln);
      console.log(Object.keys(estatekacheln)); */
      if (!exportFullPDF) {
         [page, pageNumber] = addNewPage(pdfDoc, pageNumber, regularFont, basicdata.objektnr_extern);
         const { width, height } = page.getSize();
         page.drawText(basicdata[config.estate.objektBezeichnung] ? basicdata[config.estate.objektBezeichnung] : basicdata.objektnr_extern, {
            x: pageXMargin,
            y: height - 10 - fontSize,
            size: 10,
            font: boldFont,
            color: rgb(0, 0, 0),
         });

         page.drawText(basicdata[bemerkungsfeld] ? basicdata[bemerkungsfeld] : "", {
            x: pageXMargin,
            y: height - 30 - fontSize,
            size: 10,
            font: boldFont,
            color: rgb(0, 0, 0),
         });
         console.log(ownerData);

         if (ownerData["Name"]) {
            page.drawText("Eigentümer", {
               x: pageXMargin,
               y: height - 50 - fontSize,
               size: 10,
               font: boldFont,
               color: rgb(0, 0, 0),
            });

            page.drawText(ownerData["Name"] + " " + (ownerData["Vorname"] ? ownerData["Vorname"] : ""), {
               x: pageXMargin + 100,
               y: height - 50 - fontSize,
               size: 10,
               font: boldFont,
               color: rgb(0, 0, 0),
            });

            page.drawText("KdNr:", {
               x: pageXMargin,
               y: height - 65 - fontSize,
               size: 10,
               font: boldFont,
               color: rgb(0, 0, 0),
            });

            page.drawText(ownerData["KdNr"] ? "" + ownerData["KdNr"] : "", {
               x: pageXMargin + 100,
               y: height - 65 - fontSize,
               size: 10,
               font: boldFont,
               color: rgb(0, 0, 0),
            });
         }

         page.drawText("Objektadresse:", {
            x: pageXMargin,
            y: height - 90 - fontSize,
            size: 10,
            font: boldFont,
            color: rgb(0, 0, 0),
         });

         page.drawText(
            (basicdata["strasse"] ? basicdata["strasse"] : "") +
               " " +
               (basicdata["hausnummer"] ? basicdata["hausnummer"] : ""),
            {
               x: pageXMargin + 100,
               y: height - 90 - fontSize,
               size: 10,
               font: boldFont,
               color: rgb(0, 0, 0),
            }
         );
         page.drawText((basicdata["plz"] ? basicdata["plz"] : "") + " " + (basicdata["ort"] ? basicdata["ort"] : ""), {
            x: pageXMargin + 100,
            y: height - 100 - fontSize,
            size: 10,
            font: boldFont,
            color: rgb(0, 0, 0),
         });
      }
      console.log(basicdata);
      let pdfEstateKacheln;
      if (exportFullPDF) {
         pdfEstateKacheln = structuredClone(allKacheln);
      } else {
         pdfEstateKacheln = structuredClone({ datenblatt: estatekacheln["datenblatt"] });
      }

      // Object.keys({ datenblatt: estatekacheln["datenblatt"] }).forEach((projektstufe, projektstufeIndex) => {
      Object.keys(pdfEstateKacheln).forEach((projektstufe, projektstufeIndex) => {
         let newPage;

         [newPage, pageNumber] = addNewPage(pdfDoc, pageNumber, regularFont, basicdata.objektnr_extern);
         const { width, height } = newPage.getSize();

         const title = basicdata[config.estate.objektBezeichnung] ? basicdata[config.estate.objektBezeichnung] : basicdata.objektnr_extern;

         let lineIndex = 0;

         if (exportFullPDF) {
            newPage.drawText(
               pdfEstateKacheln[projektstufe].projektHeading ? pdfEstateKacheln[projektstufe].projektHeading : "",
               {
                  x:
                     (width -
                        boldFont.widthOfTextAtSize(
                           pdfEstateKacheln[projektstufe].projektHeading
                              ? pdfEstateKacheln[projektstufe].projektHeading
                              : "",
                           15
                        )) /
                     2,
                  y: height - 20 - 20 * lineIndex,
                  size: 16,
                  font: boldFont,
                  color: rgb(0, 0, 0),
               }
            );
         } else {
            newPage.drawText(title, {
               x: (width - boldFont.widthOfTextAtSize(title, 15)) / 2,
               y: height - 30,
               size: 15,
               font: boldFont,
               color: rgb(0, 0, 0),
            });
         }
         lineIndex++;
         pdfEstateKacheln[projektstufe].kachel.forEach((kachel, kachelIndex) => {
            lineIndex += 2;

            let kachelheadingLineIndex = lineIndex;
            /* let kachelWithContent = false;
            if (exportFullPDF) {
               kachel.layout.flat().forEach((data, dataIndex) => {
                  if (basicdata[data.name] && basicdata[data.name] != "⠀") {
                     kachelWithContent = true;
                  }
               });
            } */

            if (true) {
               newPage.drawText(kachel.heading, {
                  x: pageXMargin,
                  y: height - kachelheadingLineIndex * 20,
                  size: 14,
                  font: boldFont,
                  color: rgb(0, 0, 0),
               });

               lineIndex++;

               kachel.layout.flat().forEach((data, dataIndex) => {
                  if (true || (basicdata[data.name] && basicdata[data.name] != "⠀")) {
                     lineIndex++;
                     let form = pdfDoc.getForm();

                     if (basicdata[data.name].includes("⠀")) {
                        basicdata[data.name] = "";
                     }

                     if (basicdata[data.name].constructor === Array) {
                        basicdata[data.name] = JSON.stringify(basicdata[data.name]);
                     }

                     try {
                        newPage.drawText(data.heading ? data.heading : "Überschrift fehlt", {
                           x: pageXMargin,
                           y: height + 5 - lineIndex * 20,
                           size: 10,
                           font: regularFont,
                           color: rgb(0, 0, 0),
                        });
                     } catch {
                        newPage.drawText(data.name ? data.name : "", {
                           x: pageXMargin,
                           y: height + 5 - lineIndex * 20,
                           size: 10,
                           font: regularFont,
                           color: rgb(0, 0, 0),
                        });
                     }

                     //  lineIndex++;
                     lineIndex += data.type === "textarea" ? 3 : 1;
                     createFormField(
                        newPage,
                        form,
                        projektstufeIndex + "_" + kachelIndex + "_" + data.name + lineIndex,
                        exportEmptyPDF ? "" : basicdata[data.name],
                        regularFont,
                        width,
                        height - lineIndex * 20,
                        data.type
                     );
                  }

                  if (lineIndex > maxLineNumber) {
                     lineIndex = 2;
                     [newPage, pageNumber] = addNewPage(pdfDoc, pageNumber, regularFont, exportEmptyPDF?"":basicdata.objektnr_extern);
                  }
               });
            }

            if (lineIndex > maxLineNumber) {
               [newPage, pageNumber] = addNewPage(pdfDoc, pageNumber, regularFont, exportEmptyPDF?"":basicdata.objektnr_extern);
               lineIndex = 2;
            }
         });
      });

      const pdfBytes = await pdfDoc.save();

      const blob = new Blob([pdfBytes], { type: "application/pdf" });

      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = basicdata.objektnr_extern + "_Datenblatt_" + new Date().toLocaleString() + ".pdf";
      a.click();
      window.URL.revokeObjectURL(url);
   }

   function createFormField(myPage, myForm, textFieldName, myText, myFont, width, yPosition, myType) {
      const textField = myForm.createTextField(textFieldName);

      textField.enableMultiline();
      textField.setText(myText);

      textField.addToPage(myPage, {
         x: pageXMargin,
         y: yPosition,
         width: width - 2 * pageXMargin,
         height: myType === "textarea" ? 59 : 19,
         textColor: rgb(0, 0, 0),
         backgroundColor: rgb(1, 1, 1),
         borderColor: rgb(0.9, 0.9, 0.9),
         borderWidth: 1,
         font: myFont,
      });
      const editTextField = myForm.getTextField(textFieldName);
      editTextField.setFontSize(myType === "textarea" ? 6 : 10);
   }

   return (
      <>
         {
            <div style={{ position: "relative" }}>
               <button
                  onClick={() => {
                     createPdf();
                  }}
                  className="custom-button"
                  style={{ position: "absolute", width: "56px", right: "60px", zIndex: 0 }}
                  title="Daten als PDF runterladen"
               >
                  <img src={downloadIcon} />
               </button>
            </div>
         }
      </>
   );
}
